<template>
<div>
  <div class="view-header">
    <h1>{{$store.state.meta.title}}</h1>
    <div class="func-list">
<!--      <el-button type="primary" plain>导出</el-button>-->
    </div>
  </div>
  <div class="view-filter">
    <el-form :inline="true" :model="filterForm" size="small" label-suffix=":">
      <el-form-item label="提交日期">
        <el-date-picker
          v-model="filterForm.date"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item
        v-for="(item,index) in filterList"
        :key="index"
        :label="item.field_name">
        <el-select
          v-model="filterForm.findId[index]">
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="v in item.field_value"
            :key="v.template_field_option_id"
            :label="v.field_value"
            :value="v.template_field_option_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" plain @click="onSearch">查找</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" plain @click="onExport">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
  <div class="table">
    <div class="table-header">共{{totalCount}}条结果</div>
    <el-table
      size="medium"
      :data="list"
      style="width: 100%">
      <el-table-column
        prop="report_code"
        label="报告编码"
        >
      </el-table-column>
      <el-table-column
        v-for="item in templateList"
        :prop="item.field_name"
        :label="item.field_name"
        >
        <template slot="header">
          {{item.field_name}}
          <i style="color:red;font-style:normal;" v-if="item.is_required">*</i>
        </template>
        <template slot-scope="scope">
          <span v-if="[7,9,11].indexOf(templateMap[item.field_name])===-1">{{scope.row[item.field_name]}}</span>
<!--          图片-->
          <div v-if="[9,11].indexOf(templateMap[item.field_name])>-1&&scope.row[item.field_name]&&scope.row[item.field_name]!==''">
            <el-image
              v-for="item2 of scope.row[item.field_name].split(',')"
              style="width: 40px;height: 40px;"
              :src="item2"
              @click="viewImg(item2)"
            ></el-image>
          </div>
<!--          联系人-->
          <div v-if="[7].indexOf(templateMap[item.field_name])>-1">
            <p class="ellipsis" :title="scope.row[item.field_name]">
              {{scope.row[item.field_name]}}
            </p>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="user_name"
        label="提交人"
      >
      </el-table-column>
      <el-table-column
        prop="user_phone"
        label="提交手机"
      >
      </el-table-column>
      <el-table-column
        prop="create_time"
        label="提交时间"
      >
      </el-table-column>
      <el-table-column
        label="操作"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="toViewPDF(scope.row)">
            查看PDF
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div class="pagination">
    <el-pagination
      :hide-on-single-page="totalPage<2"
      background
      :current-page="currentPage"
      :page-size="20"
      layout="prev, pager, next, jumper"
      @current-change="handleCurrentChange"
      :total="totalCount">
    </el-pagination>
  </div>
</div>
</template>

<script>
import { getTemplateField, getReportDateList, pdfCreate } from '@/api';

export default {
  name: 'userReportDetail',
  beforeCreate() {
    const { user_id, template_id } = this.$route.params;
    this.user_id = user_id;
    this.template_id = template_id;
  },
  data: () => ({
    filterForm: {
      date: [],
      findId: [],
    },
    templateList: [],
    filterList: [],
    templateMap: [],
    list: [],
    totalCount: 0,
    totalPage: 1,
    currentPage: 0,
  }),
  async created() {
    await getTemplateField(this.template_id).then((res) => {
      if (res.status === 0) {
        const templateList = res.data;
        const filterList = [];
        const findId = [];
        const templateMap = {};
        for (const item of templateList) {
          templateMap[item.field_name] = item.field_type;
          if (item.is_screen) {
            filterList.push(item);
          }
        }
        for (let i = 0; i < filterList.length; i++) {
          findId[i] = '';
        }
        const findIdList = [];
        for (const item of findId) {
          if (item && item !== '') {
            findIdList.push(item);
          }
        }
        if (findIdList && findIdList.length > 0) {
          this.filterForm.findId = findIdList;
        }

        this.templateList = templateList;
        this.filterList = filterList;
        this.templateMap = templateMap;
      } else {
        this.templateList = [];
      }
    });
    await this._getList(1);
  },
  methods: {
    onSearch() {
      this._getList(1);
    },
    viewImg(imgSrc) {

    },
    _getList(page) {
      const filterForm = { ...this.filterForm };
      const findId = [...filterForm.findId];
      const find_id = [];
      for (const item of findId) {
        if (item || item === 0) {
          find_id.push(item);
        }
      }
      const parameters = {
        find_id,
        page,
        user_id: this.user_id,
        template_id: this.template_id,
        is_download: '0',
      };
      if (filterForm.date && filterForm.date.length > 0) {
        parameters.start_date = filterForm.date[0];
        parameters.end_date = filterForm.date[1];
      }
      getReportDateList(parameters).then((res) => {
        if (res.status === 0) {
          const { data } = res;
          this.totalCount = data.totalCount;
          this.totalPage = data.totalPage;
          this.currentPage = parseInt(data.currentPage);
          const { list } = data;
          for (const item of list) {
            for (const k in item) {
              switch (this.templateMap[k]) {
                // 联系人
                case 7:
                  const arr = [];
                  for (const j of item[k]) {
                    let str = '';
                    for (const l in j) {
                      str += (`${l}:${j[l]};`);
                    }
                    arr.push(str);
                  }
                  item[k] = arr.join('\n');
                  break;
              }
            }
          }
          this.list = list;
        } else {
          this.list = [];
          this.totalCount = 0;
          this.totalPage = 1;
          this.currentPage = 0;
        }
      });
    },
    handleCurrentChange(val) {
      this._getList(val);
    },
    onExport() {
      this.$router.windowOpen({
        name: 'reportExport',
        params: { user_id: this.user_id, template_id: this.template_id },
      });
      return;
      const filterForm = { ...this.filterForm };
      const findId = [...filterForm.findId];
      const find_id = [];
      for (const item of findId) {
        if (item || item === 0) {
          find_id.push(item);
        }
      }
      const parameters = {
        find_id,
        user_id: this.user_id,
        template_id: this.template_id,
        is_download: '1',
      };
      if (filterForm.date && filterForm.date.length > 0) {
        parameters.start_date = filterForm.date[0];
        parameters.end_date = filterForm.date[1];
      }
      getReportDateList(parameters).then((res) => {
        if (res.status === 0) {
          const that = this;
          this.$confirm('成功创建导出任务，点击确认进入导出任务列表页，点击取消停留此页面！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            that.$router.push({ name: 'exportList', params: { user_id: this.user_id } });
          }).catch(() => {

          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    toViewPDF(record) {
      this.$message('pdf生成中...');
      pdfCreate(this.user_id, this.template_id, record.report_code).then((res) => {
        if (res.status === 0) {
          const { url } = res.data;
          window.open(url);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">

</style>
